import { createSelector } from "reselect";
import get from "lodash.get";

// Selectors
import { createNestedAssessmentSchemasForAssessmentAnswerSelector } from "src/selectors/data_selectors";

/**
 * Create a selector that gets the schemas for a wound assessment (attributes tab)
 * @param {Object} assessmentAnswer
 * @returns {Function} selector
 */
export function createAttributesTabSchemasForAssessmentAnswerSelector(
  assessmentAnswer
) {
  return createSelector(
    createNestedAssessmentSchemasForAssessmentAnswerSelector(assessmentAnswer),
    assessmentSchemas => {
      const tissueSchema = assessmentSchemas.find(
        schema => get(schema, "attributes.schemaJson.name", "") === "tissue"
      );
      const exudateSchema = assessmentSchemas.find(
        schema => get(schema, "attributes.schemaJson.name", "") === "exudate"
      );
      const surroundingTissueSchema = assessmentSchemas.find(
        schema =>
          get(schema, "attributes.schemaJson.name", "") === "surroundingTissue"
      );
      const painSchema = assessmentSchemas.find(
        schema => get(schema, "attributes.schemaJson.name", "") === "pain"
      );

      let attributesTabSchemas = [];
      if (tissueSchema) attributesTabSchemas.push(tissueSchema);
      if (exudateSchema) attributesTabSchemas.push(exudateSchema);
      if (surroundingTissueSchema)
        attributesTabSchemas.push(surroundingTissueSchema);
      if (painSchema) attributesTabSchemas.push(painSchema);

      return attributesTabSchemas;
    }
  );
}
